import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeUtilsService {

  // we can't just simply use the "exp" property in the jwt's response because of hard-coded values in many places in CIAM
  // therefore, we use the "iat" property + agreed expiration time in seconds
  isValid(epochTimeSeconds: number, expirationSeconds: number): boolean {
    const epochTimeMillis = epochTimeSeconds * 1000;
    const diffSeconds = (new Date().getTime() - epochTimeMillis) / 1000;
    return 0 <= diffSeconds && diffSeconds <= expirationSeconds;
  }

  // isValid(epochTimeSeconds: number): boolean {
  //   const epochTimeMillis = epochTimeSeconds * 1000;
  //   return epochTimeMillis - new Date().getTime() > 0;
  // }
}
